export default __webpack_public_path__ + "static/media/03.69769ba2.png";